<template>
  <div>
    <my-header></my-header>
    <!-- <div class="banner" @mouseover="bannerMouseover" @mouseout="bannerMouseout">
      <div class="banner-content" v-for="(item,index) in banner" :key="index">
        <div class="banner-img" :class="{'banner-show':index === bannerIndex}">
          <img :src="`${item.imgUrl}`" />
        </div>
      </div>
      <button class="banner-btn banner-left" @click="changeBannerBtn(false)">
        <i class="el-icon-arrow-left"></i>
      </button>
      <button class="banner-btn banner-right" @click="changeBannerBtn(true)">
        <i class="el-icon-arrow-right"></i>
      </button>
    </div> -->
    <el-carousel class="banner" :interval="4000" height="560px" arrow="never">
      <el-carousel-item class="banner-content" v-for="(item,index) in banner" :key="index">
        <img class="img" :src="`${item.imgUrl}`" />
      </el-carousel-item>
    </el-carousel>
    <div class="content-box platform-introduction">
      <div class="content-detail">
        <div class="data">
          <div class="li">
            <p class="num">{{webInfo.pubQuestionCount}}<span class="plus">+</span></p>
            <p class="info">公共题目总数</p>
          </div>
          <div class="li">
            <p class="num">{{webInfo.questionCount - webInfo.pubQuestionCount}}<span class="plus">+</span></p>
            <p class="info">个人题目总数</p>
          </div>
          <div class="li">
            <p class="num">{{webInfo.userCount}}<span class="plus">+</span></p>
            <p class="info">注册人数</p>
          </div>
          <div class="li">
            <p class="num">{{webInfo.orgCount}}<span class="plus">+</span></p>
            <p class="info">注册单位</p>
          </div>
          <div class="border b1"></div>
          <div class="border b2"></div>
          <div class="border b3"></div>
        </div>
        <p class="title">平台简介</p>
        <p class="text">星火影像教学平台是以医学影像终身学习为核心的专业化教学平台，致力以“权威题库、住培进阶、终身学习”为一体，构建完整的闭环式服务体系，独创 SPARK系统化教学模式，满足不同医学影像人才在医学院校教育、毕业后教育和继续教育不同阶段的多种需求，实现随时可学且终身求学而有获的学习环境。</p>
        <img class="bg" src="/static/img/index/introduction.png"/>
        <ul class="list">
          <li class="li" v-for="(item,index) in sparkList" :key="index">
            <img class="img" :src="item.img"/>
            <div class="text-box">
              <p class="text-1">{{item.title}}</p>
              <p class="text-2">{{item.text}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="content-box platform-module">
      <div class="content-detail">
        <p class="title">平台板块</p>
        <p class="text">涵盖六位一体亚专科  开拓住培发展新局面</p>
        <!-- <el-carousel
          height="284px"
          indicator-position="none"
          class="img-carousel"
          arrow="never"
          ref="carousel"
          :interval="1500"
          @change="changeBanner"
        >
          <el-carousel-item v-for="(item,index) in imgList" :key="index" class="img-carousel-item">
            <div class="img-box">
              <img class="img" :src="item.img" @click="setActiveItem(index, item)" />
              <p class="text">{{item.name}}</p>
            </div>
          </el-carousel-item>
        </el-carousel> -->
        <swiper
          class="img-carousel"
          :options="swiperOption"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          v-if="imgList.length > 0"
        >
          <swiper-slide v-for="(item,index) in imgList" :key="index" class="img-carousel-item">
            <div class="img-box">
              <img class="img" :src="item.img" @click="setActiveItem(index, item)" />
              <p class="text">{{item.name}}</p>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="content-box platform-advantage">
      <div class="content-detail">
        <p class="title">平台优势</p>
        <p class="text">打造高质量教学系统  凸显专业化核心优势</p>
        <ul class="list">
          <li class="li" v-for="(item, index) in advantageList" :key="index" :style="`background-image: url('${item.img}')`">
            <p class="name">{{item.name}}</p>
            <p class="info" v-for="(item1, index1) in item.text" :key="index1">{{item1}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="content-box platform-worth">
      <div class="content-detail">
        <p class="title">平台价值</p>
        <p class="text">满足多样化服务需求  构建多方共赢新生态</p>
        <ul class="list">
          <li class="li" v-for="(item,index) in worthList" :key="index">
            <img :src="item.img"/>
            <p class="name">{{item.name}}</p>
            <p class="info">{{item.info}}</p>
          </li>
        </ul>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
// import deepCopy from '@/utils/deepcopy'
import { officialSiteServer } from '@/api/api'
import getImgUrl from '@/mixin/getImgUrl.js'
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
export default {
  name: 'index',
  components: {
    myHeader: myHeader,
    myFooter: myFooter
  },
  mixins: [getImgUrl],
  data () {
    return {
      bannerIndex: 0,
      banner: [],
      sparkList: [
        {
          img: '/static/img/index/S.png',
          title: '亚专业教学（S）',
          text: '邀请权威大咖进行专题讲座，设有监督学习锚点，课前和课后双重测试，有助于评估听课效果。'
        },
        {
          img: '/static/img/index/P.png',
          title: '问题导向学习法（P）',
          text: '简答题以最新权威影像教材为蓝本，支持语音输入，平台依据关键词个数自动给分，准确率需达一定百分比才能提交，准确率大幅提升。'
        },
        {
          img: '/static/img/index/A.png',
          title: '考核评估（A）',
          text: '最佳影像结果判读，包含危急值、常见/多发病变、亚专科等各类题型，绝大部分题目均经病理证实（脑出血、气胸、骨折等无需病理证实的病种除外），并且病理即为答案。'
        },
        {
          img: '/static/img/index/R.png',
          title: '报告书写（R）',
          text: '影像报告书写，基本覆盖所有常见病，关键词设定为下拉框式选择题，选择正确后答案方可提交成功，全流程指导式，医学影像诊断报告更规范、客观、全面，提升报告书写质量及能力。'
        },
        {
          img: '/static/img/index/K.png',
          title: '阅片技能培训（K）',
          text: '基于病例的微课，每个课程仅3-5分钟，集中精讲精华知识点，便于在空余间隙进行碎片化学习，大大提高学习效率。'
        }
      ],
      worthList: [
        { img: '/static/img/index/person.png', name: '个人', info: '有效学习管理机制  提升医学影像技能' },
        { img: '/static/img/index/school.png', name: '学校', info: '夯实影像教育基础  助力影像人才培养' },
        { img: '/static/img/index/hospital.png', name: '医院', info: '推进住培提质增效  提升综合学科建设' },
        { img: '/static/img/index/government.png', name: '政府', info: '提供数据决策依据  加强住培教学监督' }
      ],
      imgList: [
        { name: '放射诊断学', img: '/static/img/index/fangshezhenduan.png' },
        { name: '放射技术学', img: '/static/img/index/fangshejishu.png' },
        { name: '超声影像学', img: '/static/img/index/chaosheng.png' },
        { name: '核医学', img: '/static/img/index/heyi.png' },
        { name: '心电学', img: '/static/img/index/xindian.png' },
        { name: '病理学', img: '/static/img/index/bingli.png' },
        { name: '内镜学', img: '/static/img/index/neijing.png' }
      ],
      advantageList: [
        { name: '专业平台', text: ['教学考练赛事一体化', '创新学习管理机制'], img: '/static/img/index/zypt.png' },
        { name: '权威题库', text: ['23000+精选好题', '影像类别全面涵盖'], img: '/static/img/index/qwtk.png' },
        { name: '超强阵容', text: ['汇集全国40+专业基地', '师资队伍实力雄厚'], img: '/static/img/index/cqzr.png' },
        { name: '创新模式', text: ['个性化教学', '过程化教学', '分层分级'], img: '/static/img/index/cxms.png' },
        { name: '寓教于乐', text: ['组局pk每日一练', '升级强化助力成长'], img: '/static/img/index/yjyl.png' }
      ],
      webInfo: {
        pubQuestionCount: '',
        orgCount: '',
        questionCount: '',
        userCount: ''
      },
      swiperOption: {
        slidesPerView: 1,
        // 设置自动轮播
        autoplay: {
          disableOnInteraction: false,
          delay: 0 // 5秒切换一次
        },
        speed: 8000,
        // 设置轮播可循环
        loop: true,
        circular: true
      }
    }
  },
  beforeDestroy () {
    if (this.bannerT) clearInterval(this.bannerT)
  },
  mounted () {
    this.imgList = this.imgList.concat(this.imgList)
    this.imgList = this.imgList.concat(this.imgList)
    this.imgList = this.imgList.concat(this.imgList)
    this.readBanner()
  },
  methods: {
    onSwiper () {},
    onSlideChange () {},
    /**
     * 切换显示的文字信息
     * @function changeBanner
     * @param {Number} index 对应的索引值
     */
    changeBanner (index) {
      this.bannerIndex = index
    },
    changeBannerBtn (flag) {
      if (flag) {
        this.bannerIndex++
        if (this.bannerIndex >= this.banner.length) {
          this.bannerIndex = 0
        }
      } else {
        this.bannerIndex--
        if (this.bannerIndex < 0) {
          this.bannerIndex = this.banner.length - 1
        }
      }
    },
    initBannerT () {
      this.bannerT = setInterval(() => {
        if (this.bannerT) clearInterval(this.bannerT)
        this.bannerIndex++
        if (this.bannerIndex >= this.banner.length) {
          this.bannerIndex = 0
        }
        this.initBannerT()
      }, 2000)
    },
    bannerMouseover () {
      if (this.bannerT) clearInterval(this.bannerT)
    },
    bannerMouseout () {
      if (this.bannerT) clearInterval(this.bannerT)
      this.initBannerT()
    },
    readBanner () {
      officialSiteServer.index().then((res) => {
        let { code, data } = res
        if (code === '0') {
          this.webInfo.pubQuestionCount = data.pubQuestionCount
          this.webInfo.orgCount = data.orgCount
          this.webInfo.questionCount = data.questionCount
          this.webInfo.userCount = data.userCount
          let img = data.img ? data.img.split(',') : []
          img.forEach(e => {
            this.banner.push({
              img: e
            })
          })
          this.getImgUrl(this.banner, 'img')
          if (this.banner.length > 1) this.initBannerT()
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
.banner {
  width: 100%;
  height: 560px;
  text-align: center;
  position: relative;
  .banner-content {
    display: inline-block;
    overflow: hidden;
    // min-width: 1200px;
    // max-width: 1920px;
    width: 100%;
    height: 560px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .img {
    width: 100%;
    height: 100%;
    // width: 1920px;
    // height: 560px;
  }
  .banner-btn {
    position: absolute;
    top: 360px;
    color: #fff;
    border: 1px solid #fff;
    width: 60px;
    height: 60px;
    background: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    visibility: hidden;
    opacity: 0;
  }
  .banner-left {
    left: 70px;
    transform: translateX(-70px);
  }
  .banner-right {
    right: 70px;
    transform: translateX(70px);
  }
  // .banner-img {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 750px;
  //   overflow: hidden;
  //   opacity: 0;
  //   transition: all 0.6s;
  //   img {
  //     position: absolute;
  //     width: 1920px;
  //     height: 750px;
  //     top: 0;
  //     left: 0;
  //     transform: scale(1.2);
  //     transition: all 0.6s;
  //   }
  // }
  .banner-show {
    opacity: 1;
    img {
      transform: scale(1);
    }
  }
}
.banner:hover {
  .banner-btn {
    visibility: visible;
    transform: translateX(0);
    opacity: 1;
  }
}
/deep/.swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.platform-introduction {
  height: 755px;
  z-index: 100;
  .content-detail {
    height: 755px;
    padding-top: 185px;
  }
  .data {
    width: 1200px;
    height: 130px;
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 8px;
    position: absolute;
    top: -65px;
    left: 0;
    font-size: 0;
    .li {
      width: 300px;
      height: 130px;
      display: inline-block;
      vertical-align: top;
      margin: 0;
      padding-top: 24px;
    }
    .num {
      font-family: SourceHanSansSC-Medium;
      font-size: 48px;
      color: #0C59EF;
      height: 48px;
      line-height: 48px;
      margin-bottom: 14px;
    }
    .plus {
      font-size: 24px;
    }
    .info {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      font-weight: 400;
    }
    .border {
      width: 1px;
      height: 40px;
      background: #D8D8D8;
      border-radius: 1px;
      position: absolute;
      top: 45px;
    }
    .b1 {
      left: 299px;
    }
    .b2 {
      left: 599px;
    }
    .b3 {
      left: 899px;
    }
  }
  .title {
    font-family: SourceHanSansSC-Medium;
    font-size: 38px;
    color: #000000;
    margin-bottom: 30px;
  }
  .text {
    font-family: SourceHanSansSC-Regular;
    font-size: 18px;
    color: #5C5C5C;
    line-height: 32px;
    font-weight: 400;
    margin-bottom: 56px;
    text-align: left;
  }
  .bg {
    position: absolute;
    bottom: 30px;
    left: -110px;
    z-index: 1;
  }
  .list {
    position: relative;
    z-index: 10;
    .li {
      width: 215px;
      height: 215px;
      display: inline-block;
      vertical-align: top;
      margin-right: 30px;
      position: relative;
      perspective: 1000;
    }
    .li:last-child {
      margin: 0;
    }
    .img {
      width: 215px;
      height: 215px;
      display: inline-block;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      border-radius: 16px;
      position: absolute;
      left: 0;
      top: 0;
      transition: ease-in-out .6s;
      transform-style: preserve-3d;
      backface-visibility: hidden;
    }
    .text-box {
      width: 215px;
      height: 215px;
      position: absolute;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      border-radius: 16px;
      left: 0;
      top: 0;
      transition: ease-in-out .6s;
      transform-style: preserve-3d;
      transform: rotateY(180deg);
      backface-visibility: hidden;
      background-image: url("/static/img/index/introduction-box.png");
      padding: 23px 8px 0 9px;
    }
    .text-1 {
      font-family: SourceHanSansSC-Bold;
      font-size: 14px;
      color: #FFFFFF;
      text-align: justify;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .text-2 {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #FFFFFF;
      text-align: justify;
    }
    .li:hover {
      .img {
        transform: rotateY(180deg);
      }
      .text-box {
        transform: rotateY(0);
      }
    }
  }
}
.platform-module {
  height: 695px;
  background: url("/static/img/index/module.jpg") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  .content-detail {
    padding-top: 120px;
  }
  .title {
    font-family: SourceHanSansSC-Medium;
    font-size: 38px;
    color: #000000;
    margin-bottom: 30px;
  }
  .text {
    font-family: SourceHanSansSC-Regular;
    font-size: 18px;
    color: #5C5C5C;
    line-height: 32px;
    margin-bottom: 56px;
  }
}
.platform-advantage {
  height: 711px;
  background: url("/static/img/index/advantage.jpg") no-repeat;
  background-size: 100% 100%;
  .content-detail {
    padding-top: 120px;
  }
  .title {
    font-family: SourceHanSansSC-Medium;
    font-size: 38px;
    color: #fff;
    margin-bottom: 30px;
  }
  .text {
    font-family: SourceHanSansSC-Regular;
    font-size: 18px;
    color: #fff;
    line-height: 32px;
    margin-bottom: 56px;
  }
  .list {
    text-align: left;
  }
  .li {
    width: 227px;
    height: 300px;
    display: inline-block;
    vertical-align: top;
    padding: 43px 0 0 20px;
    margin-right: 16px;
    transition: all .3s;
    image-rendering: optimizeSpeed;
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: optimize-contrast;
    image-rendering: -o-pixelated;
    image-rendering: pixelated;
    -ms-interpolation-mode: nearest-neighbor;
  }
  .li:last-child {
    margin: 0;
  }
  .name {
    font-family: SourceHanSansSC-Medium;
    font-size: 24px;
    color: #000000;
    margin-bottom: 28px;
  }
  .info {
    font-family: SourceHanSansSC-Regular;
    font-size: 18px;
    color: #666666;
    position: relative;
    padding-left: 8px;
  }
  .info::before {
    content: '.';
    font-size: 30px;
    position: absolute;
    top: -18px;
    left: -5px;
  }
  .li:hover {
    transform: translateY(-20px);
  }
}
.platform-worth {
  height: 747px;
  background: #ffffff;
  .content-detail {
    padding-top: 120px;
  }
  .title {
    font-family: SourceHanSansSC-Medium;
    font-size: 38px;
    color: #000000;
    margin-bottom: 30px;
  }
  .text {
    font-family: SourceHanSansSC-Regular;
    font-size: 18px;
    color: #5C5C5C;
    line-height: 32px;
    margin-bottom: 56px;
  }
  .list {
    width: 1200px;
    font-size: 0;
    .li {
      width: 556px;
      height: 128px;
      display: inline-block;
      background: #FFFFFF;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      border-radius: 8px;
      position: relative;
      margin-bottom: 76px;
      padding: 31px 0 0 160px;
    }
    .li:nth-child(odd) {
      margin-right: 88px;
    }
    img {
      width: 92px;
      height: 92px;
      position: absolute;
      top: 18px;
      left: 40px;
    }
    .name {
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #000000;
      text-align: left;
      margin-bottom: 10px;
    }
    .info {
      font-family: SourceHanSansSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: justify;
    }
  }
}
@media (min-width: 1921px) {
  .banner {
    .banner-img {
      img {
        width: 2048px;
        height: 750px;
      }
    }
  }
}
@media (min-width: 1550px) and(max-width: 1700px) {
  .banner {
    .banner-img {
      img {
        left: -140px;
      }
    }
  }
}
@media (min-width: 1400px) and(max-width: 1549px) {
  .banner {
    .banner-img {
      img {
        left: -250px;
      }
    }
  }
}
@media (max-width: 1399px) {
  .banner {
    .banner-img {
      img {
        left: -280px;
      }
    }
  }
}
</style>
<style rel="stylesheet/less" lang="less">
.index-carousel {
  overflow: hidden;
  .el-carousel__button {
    padding: 0;
    width: 14px;
    height: 14px;
    border: 2px solid #d1e4ff;
    border-radius: 50%;
    background-color: transparent;
  }
  .is-active {
    .el-carousel__button {
      background-color: #d1e4ff;
    }
  }
}
.img-carousel {
  width: 411px;
  overflow: inherit !important;
  .img-carousel-item {
    transition: all 0.2s;
    overflow: inherit;
    .img-box {
      width: 387px;
      height: 284px;
      border-radius: 20px;
      overflow: hidden;
      position: relative;
      box-shadow: 0 2px 10px 2px rgba(30, 60, 114, 0.2);
      transform: translate(10px, 0);
      transition: all 0.2s;
      background-color: #fff;
    }
    .text {
      font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #000000;
    }
    .img {
      width: 387px;
      height: 184px;
      position: relative;
      z-index: 1;
      transform: translate(0, 0);
      transition: all 0.2s;
      cursor: pointer;
      margin-bottom: 32px;
    }
  }
  .img-carousel-item:hover {
    width: 406px;
    .img-box {
      width: 406px;
      height: 298px;
      transform: translate(0, -7px);
    }
    .img {
      width: 406px;
      height: 198px;
      margin-bottom: 28.7px;
    }
    .text {
      color: #0056F8;
    }
  }
}
</style>
<style lang="less">
.banner {
  .el-carousel__indicators--horizontal {
    bottom: 80px;
  }
  .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #BDBDBD;
    border-radius: 8px;
    opacity: 1;
  }
  .is-active {
    .el-carousel__button {
      width: 20px;
      background: #0056F8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue